export default {
  bottom: '0 4px 2px -1px rgba(0, 0, 0, 0.2)',
  bottomLight: '0 4px 2px -1px rgba(0, 0, 0, 0.1)',
  subtle: '4px 4px 10px 0px rgba(65, 79, 101, 0.15)',
  highlight: '4px 4px 10px 0px rgba(235, 110, 70, 0.1)',
};
